import { render, staticRenderFns } from "./forsublink.vue?vue&type=template&id=51155226&"
import script from "./forsublink.vue?vue&type=script&lang=js&"
export * from "./forsublink.vue?vue&type=script&lang=js&"
import style0 from "./forsublink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports